import {clearfix, oneHalf, colors} from '@xpertdox_js/xdstyle';

export default {
  container: {
    // marginRight: '10px',
    // padding: '15px 0px',
  },
  heading: {
    fontSize: '18px',
    fontWeight: '600',
    margin: '0 0 0 2px'
  },
  headerWrap: {
    ...clearfix,
    padding: '5px 0',
    marginBottom: '14px',
    borderBottom: '1px solid rgba(0,0,0,0.1)'
  },
  half: oneHalf,
  uploadBtn: {
    marginTop: '1px',
    padding: '5px 12px',
    fontWeight: 'bold',
    fontSize: '1.42rem',
    color: colors.xdDarkBlue,
    fill: colors.xdDarkBlue,
    // background: colors.xdFadedBlue,
    background: 'none',
    borderRadius: '200px',
    transition: 'background .18s, color .18s, fill .18s, box-shadow .32s',
    boxShadow: 'none',
    verticalAlign: 'top',
    float: 'left',
  },
  uploadBtnHov: {
    background: '#fff',
    boxShadow: '0 2px 2px rgba(0,0,0,0.1)',
    color: colors.xdHighlight,
    fill: colors.xdHighlight,
  },
  uploadBtnIcon: {
    display: 'block',
    float: 'left',
    marginRight: '8px',
    width: '1.8rem',
    height: '1.8rem'
  },
  uploadBtnText: {
    display: 'inline-block',
  },
  seperator: {
    display: 'inline-block',
    verticalAlign: 'top',
    margin: '0 5px',
    width: '1px',
    borderRadius: '2px',
    minHeight: '100%',
    height: '16px',
    transform: 'translateY(8px)',
    background: 'rgba(0,0,0,0.24)'
  }
}
